<!-- //
组件-单行标题
@auth xuyd
@date 2024-05-03
//-->
<template>
  <PropsWrapper :widgetProps="widgetProps">
    <el-form @submit.native.prevent :model="viewProps" size="mini" :label-width="this.dvContants.labelWidth">
      <el-form-item prop="color" label="字体颜色">
        <ColorSelector v-model="viewProps.color" style="width: 100%"/>
      </el-form-item>
      <el-form-item prop="fontSize" label="字体大小">
        <el-input v-model="viewProps.fontSize" style="width: 100%">
          <template slot="append">px</template>
        </el-input>
      </el-form-item>
      <el-form-item prop="fontWeight" label="字体粗细">
        <el-input v-model="viewProps.fontWeight" style="width: 100%"/>
      </el-form-item>
      <el-form-item prop="textAlign" label="字体位置">
        <el-select
            v-model="viewProps.textAlign"
            placeholder="请选择"
            style="width: 100%">
          <el-option
              v-for="item in this.$store.getters.dictType['PROPS_TEXT_ALIGN']"
              :key="item.value"
              :label="item.label"
              :value="item.value"
          />
        </el-select>

      </el-form-item>
    </el-form>
  </PropsWrapper>
</template>

<script>
export default {
  name: 'WidgetTitlePropsForm',
  components: {},
  dictTypes: [
    {dictType: 'PROPS_TEXT_ALIGN', dataType: String},
  ],
  data() {
    return {}
  },
  computed: {
    viewProps() {
      return this.widgetProps.viewProps;
    }
  },
  props: {
    widgetProps: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods: {}
}
</script>

<style lang="less" scoped>

</style>

